export default __webpack_public_path__ + "static/SSSpyView_screenshot-2@2x-4c3a62115453b2c036acc4a0b4fb84b0.webp";